<template>
  <div class="p-4 configuration-page">
    <h2 class="page-title mb-4">Configuration</h2>
    <b-row>
      <b-col
        v-for="group in visibleGroups"
        :key="group.title"
        md="6"
        lg="4"
        class="mb-4"
      >
        <div class="category-card h-100" :class="group.colorClass">
          <h5 class="category-title">{{ group.title }}</h5>
          <b-list-group flush>
            <b-list-group-item
              v-for="item in group.items"
              :key="item.title"
              :to="item.to"
              class="config-item"
            >
              <i class="item-icon" :class="item.icon"></i> {{ item.title }}
            </b-list-group-item>
          </b-list-group>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { masterGroups } from '@/config/masters';

export default {
  name: 'ConfigurationPage',
  computed: {
    ...mapGetters({
      userAccess: 'auth/userAccess',
    }),
    visibleGroups() {
      return masterGroups
        .map((group) => ({
          ...group,
          items: group.items.filter((item) => this.canRead(item.permission)),
        }))
        .filter((group) => group.items.length);
    },
  },
  methods: {
    canRead(module) {
      // Array permission = boleh baca kalau salah satu aja kena.
      if (Array.isArray(module)) return module.some((entry) => this.canRead(entry));
      if (!this.userAccess || !this.userAccess[module]) return false;
      return this.userAccess[module].includes('read');
    },
  },
};
</script>

<style scoped>
.configuration-page {
  background-color: #f8f9fa;
  min-height: 100vh;
}

.page-title {
  color: #333;
  font-weight: 600;
}

.category-card {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.05);
  transition: all 0.3s ease;
  overflow: hidden;
  border-top: 5px solid transparent;
}

.category-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0,0,0,0.1);
}

.category-title {
  padding: 1rem 1.25rem;
  margin-bottom: 0;
  background-color: transparent;
  font-weight: 600;
  color: #495057;
}

.config-item {
  display: flex;
  align-items: center;
  padding: 1rem 1.25rem;
  color: #212529;
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;
  border: none;
}

.config-item:hover {
  background-color: #f8f9fa;
  color: var(--mz-primary-ink); /* Use app's primary color for hover text */
}

.item-icon {
  font-size: 1.2rem;
  margin-right: 1rem;
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.config-item:hover .item-icon {
  transform: scale(1.1);
  color: #fff;
}

.list-group-item {
  border-left: none;
  border-right: none;
}

/* Application Color Palette */
/* User Management - Info */
.color-user-management { border-top-color: #5dade2; }
.color-user-management .item-icon { background-color: #eaf5fc; color: #5dade2; }
.config-item:hover .color-user-management .item-icon { background-color: #5dade2; }

/* Company & Asset - Success */
.color-company-asset { border-top-color: #2ecc71; }
.color-company-asset .item-icon { background-color: #eafaf1; color: #2ecc71; }
.config-item:hover .color-company-asset .item-icon { background-color: #2ecc71; }

/* Sensors & Tanks - Warning */
.color-sensors-tanks { border-top-color: #f1c40f; }
.color-sensors-tanks .item-icon { background-color: #fef9e7; color: #f1c40f; }
.config-item:hover .color-sensors-tanks .item-icon { background-color: #f1c40f; }

/* Bunkering & Fuel - Secondary */
.color-bunkering-fuel { border-top-color: #8e44ad; }
.color-bunkering-fuel .item-icon { background-color: #f4eef6; color: #8e44ad; }
.config-item:hover .color-bunkering-fuel .item-icon { background-color: #8e44ad; }

/* System Configuration - Danger */
.color-system-config { border-top-color: #e74c3c; }
.color-system-config .item-icon { background-color: #fdedec; color: #e74c3c; }
.config-item:hover .color-system-config .item-icon { background-color: #e74c3c; }

/* Events - Dark */
.color-events { border-top-color: #2c3e50; }
.color-events .item-icon { background-color: #ebedef; color: #2c3e50; }
.config-item:hover .color-events .item-icon { background-color: #2c3e50; }

/* Notification - Info */
.color-notification { border-top-color: #3498db; }
.color-notification .item-icon { background-color: #ebf5fb; color: #3498db; }
.config-item:hover .color-notification .item-icon { background-color: #3498db; }

/* Daily Report - Teal */
.color-daily-report { border-top-color: #16a085; }
.color-daily-report .item-icon { background-color: #e8f8f5; color: #16a085; }
.config-item:hover .color-daily-report .item-icon { background-color: #16a085; }

/* General - Primary */
.color-general { border-top-color: var(--mz-primary-line); }
.color-general .item-icon { background-color: #fff0f7; color: var(--mz-primary-ink); }
.config-item:hover .color-general .item-icon { background-color: var(--mz-primary); }

</style>
